const createScrollYObserver = (root) => {
  // State labels (returned by callback)
  const REACHED_UP = 'reachedTop';
  const REACHED_DOWN = 'downReached';

  // Option labels (parameters)
  const UP_THRESHOLD = 'upThreshold';
  const DOWN_THRESHOLD = 'downThreshold';
  const MIN_Y = 'minY';

  const DEFAULT_OPTIONS = {
    [UP_THRESHOLD]: 0,
    [DOWN_THRESHOLD]: 0,
    [MIN_Y]: 0,
  };

  let listeners = [];

  let currentScrollY;
  let lastScrollY;
  let lastDeltaY = 0;
  let distanceUp = 0;
  let distanceDown = 0;

  const update = () => {
    currentScrollY = root.scrollY;
    const deltaY = currentScrollY - lastScrollY;

    // Prevent very small scroll contrasts from tainting the data
    if (deltaY + lastDeltaY === 0) return;

    if (currentScrollY > lastScrollY) {
      // Scrolling down
      distanceDown += currentScrollY - lastScrollY;
      distanceUp = 0;
    } else {
      distanceUp += lastScrollY - currentScrollY;
      distanceDown = 0;
    }

    lastDeltaY = deltaY;
    lastScrollY = currentScrollY;
  };

  const handleScroll = () => {
    update();

    listeners.forEach((listener, i) => {
      let emitCallback = false;

      const [callback, options, state] = listener;

      if (currentScrollY < options[MIN_Y]) {
        if (state[REACHED_UP] || state[REACHED_DOWN]) {
          state[REACHED_UP] = false;
          state[REACHED_DOWN] = false;

          emitCallback = true;
        }
      } else {
        if (distanceUp > options[UP_THRESHOLD]) {
          if (state[REACHED_UP]) return;

          state[REACHED_UP] = true;
          state[REACHED_DOWN] = false;

          emitCallback = true;
        }

        if (distanceDown > options[DOWN_THRESHOLD]) {
          if (state[REACHED_DOWN] || !state[REACHED_UP]) return;

          state[REACHED_UP] = false;
          state[REACHED_DOWN] = true;

          emitCallback = true;
        }
      }

      if (emitCallback) {
        callback(state, i);
      }
    });
  };

  const observe = (callback, options) => {
    const state = {
      [REACHED_UP]: false,
      [REACHED_DOWN]: false,
    };

    return listeners.push([callback, { ...DEFAULT_OPTIONS, ...options }, state]);
  };

  const unobserve = (listenerIndex) => {
    listeners = listeners.filter((_, i) => i !== listenerIndex);
  };

  const start = () => {
    currentScrollY = root.scrollY;
    lastScrollY = currentScrollY;

    root.addEventListener('scroll', handleScroll);
  };

  const end = () => {
    root.removeEventListener('scroll', handleScroll);
  };

  return [observe, unobserve, start, end];
};

export default class {
  constructor(root = window) {
    const [observe, unobserve, start, end] = createScrollYObserver(root);

    // Public methods
    this.observe = observe;
    this.unobserve = unobserve;
    this.start = start;
    this.end = end;
  }
}
